import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

// Tarjeta reutilizable para estados de error de carga de datos (backend caído,
// timeout, etc.). Ofrece un botón "Reintentar" que reejecuta el fetch.
const LoadErrorCard = ({
  onRetry,
  title = 'No se pudo cargar la información',
  message = 'No pudimos obtener los datos. Verifica tu conexión e inténtalo de nuevo.',
  retrying = false,
  testId = 'load-error-card',
}) => {
  return (
    <div className="flex items-center justify-center py-12" data-testid={testId}>
      <div className="max-w-md w-full bg-white rounded-2xl border border-slate-200 p-8 text-center">
        <div className="w-12 h-12 mx-auto rounded-full bg-red-50 flex items-center justify-center mb-4">
          <AlertCircle className="w-6 h-6 text-red-500" />
        </div>
        <h2 className="font-heading text-lg font-bold text-slate-900 mb-1">{title}</h2>
        <p className="text-slate-500 text-sm mb-5">{message}</p>
        {onRetry && (
          <Button onClick={onRetry} disabled={retrying} data-testid={`${testId}-retry-btn`}>
            <RefreshCw className={`w-4 h-4 mr-2 ${retrying ? 'animate-spin' : ''}`} /> Reintentar
          </Button>
        )}
      </div>
    </div>
  );
};

export default LoadErrorCard;
